<mat-dialog-content class="custom-modal-container">
  <h5 class="text-center text-title-modal" mat-dialog-title>
    {{ data.bankName | capitalizeInitialsPipe }}
  </h5>

  <div class="row">
    <div class="col-lg-12 text-center">
      <div class="row">
        <div class="col-md-6">
          <span class="text-white">Max-Positions:</span>
          <h5 class="text-black">
            {{ data.maxPositions || 'Not specified' }}
          </h5>
        </div>
        <div class="col-md-6">
          <span class="text-white">Min-Credit:</span>
          <h5 class="text-black">
            {{ data.minCredit || 'Not specified' }}
          </h5>
        </div>
        <div class="col-md-6">
          <span class="text-white">Min-Deposit:</span>
          <h5 class="text-black">
            {{ data.minDeposit || 'Not specified' }}
          </h5>
        </div>
        <div class="col-md-6">
          <span class="text-white">Deposit Amount:</span>
          <h5 class="text-black">
            {{ data.depositsAmount || 'Not specified' }}
          </h5>
        </div>
        <div class="col-md-6">
          <span class="text-white">Negative-Max-Day:</span>
          <h5 class="text-black">
            {{ data.negativeMaxDay || 'Not specified' }}
          </h5>
        </div>
      </div>
    </div>
  </div>
  <mat-dialog-actions class="text-black-50 justify-content-center">
    <button
      (click)="close()"
      class="btn btn-block btn-sm btn-info text-white"
      mat-button
    >
      Close
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
